import { inject, observer } from "mobx-react";

import { Toast } from "primereact/toast";
import { useEffect, useRef } from "react";

import "./style.scss";

const ToastComponent = inject("mainStore")(
    observer(({ mainStore }) => {
        const toast = mainStore.getMainStore("toast");
        const toastRef = useRef(null);

        useEffect(() => {
            if (toast) toastRef.current.show(toast);
        }, [toast]);

        return <Toast ref={toastRef} className="toast-component" />;
    }),
);

export default ToastComponent;
